import { HeaderInfoService } from './../../../servicios/header-info.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(private headerInfoService: HeaderInfoService) { }

  public tituloPagina: string;
  public conjunto: string;
  public tituloTarjeta: string;
  public textoTarjeta: string;
  public imagenTarjeta: string;
  public imagenUnidad: string;
  public soloBotonMenu: boolean;


  ngOnInit() {
    this.tituloPagina = this.headerInfoService.tituloPagina.value;
    this.conjunto = this.headerInfoService.conjunto.value;
    this.tituloTarjeta = this.headerInfoService.tituloTarjeta.value;
    this.textoTarjeta = this.headerInfoService.textoTarjeta.value;
    this.imagenTarjeta = this.headerInfoService.imagenTarjeta.value;
    this.imagenUnidad = this.headerInfoService.imagenUnidad.value;
    this.soloBotonMenu = this.headerInfoService.soloBotonMenu.value;

    this.headerInfoService.tituloPagina.subscribe(nuevoTituloPagina => this.tituloPagina = nuevoTituloPagina);
    this.headerInfoService.conjunto.subscribe(nuevoConjunto => this.conjunto = nuevoConjunto);
    this.headerInfoService.tituloTarjeta.subscribe(nuevoTituloTarjeta => this.tituloTarjeta = nuevoTituloTarjeta);
    this.headerInfoService.textoTarjeta.subscribe(nuevoTextoTarjeta => this.textoTarjeta = nuevoTextoTarjeta);
    this.headerInfoService.imagenTarjeta.subscribe(nuevaImagenTarjeta => this.imagenTarjeta = nuevaImagenTarjeta);
    this.headerInfoService.imagenUnidad.subscribe(nuevaImagenUnidad => this.imagenUnidad = nuevaImagenUnidad);
    this.headerInfoService.soloBotonMenu.subscribe(nuevoSoloBotonMenu => this.soloBotonMenu = nuevoSoloBotonMenu);
    
    this.headerInfoService.traerDatosPerfil().subscribe(() => {
    }, err => {
    });
  }

  public toggleMenu() {
    this.headerInfoService.toggleMenu()
  }

}
